import React, { Component, PropTypes } from "react"
import { withRouter } from 'react-router-dom'
import { Form, Input, Icon, Button, message } from "antd"
import { observer , inject} from "mobx-react"
import { observable, action } from "mobx"
const FormItem = Form.Item

const windowsAd=
"http://sw.bos.baidu.com/sw-search-sp/software/14aca1f5063ab/ChromeStandalone_59.0.3071.115_Setup.exe"
const macAd =
"http://sw.bos.baidu.com/sw-search-sp/software/24cfe13c55d9d/googlechrome_mac_59.0.3071.109.dmg"
const downloadAddress = /macintosh|mac os x/i.test(navigator.userAgent) ? macAd : windowsAd

@inject('entrance')@observer
class Login extends Component {
    @observable loginInfo = {
      username:"",
      password:""
    }

    static contextTypes = {
      router: PropTypes.object.isRequired
    }

    @action
    changeForm = (e, field) => this.loginInfo[field] = e.target.value

    login = () => {
      const { auth, history, entrance } = this.props
      auth.login(this.loginInfo)
      .then(() => {
        auth.loadUserInfo()
        .then(() => {
          entrance.getTemplates(auth.userInfo.orgId)
        })
        history.replace('/public/start/apps')
      }, error => {
        message.error(error.message)
      })
    }

    render() {
      const { auth } = this.props

      return (
        <section>
          <Form>
            <div>
              <FormItem>
                <Icon type="user" />
                <Input size="large"
                  placeholder="请输入您的用户名"
                  value={this.loginInfo.username} name="username"
                  onChange={(e)=>this.changeForm(e,"username")} />
              </FormItem>
              <FormItem>
                <Icon type="lock" />
                <Input size="large"
                  placeholder="请输入您的密码"
                  type="password" value={this.loginInfo.password}
                  name="password" onChange={(e)=>this.changeForm(e,"password")} />
              </FormItem>
              <FormItem>
              <Button size="large"
                type="primary"
                htmlType="submit" onClick={this.login}>登录</Button>
              <div className="button-shadown"></div>
              </FormItem>
              <footer>
                <a href={downloadAddress}>下载最新版浏览器master</a>
                <a onClick={() => auth.updateFormType("forgetPassword")} className="pull-right">忘记密码</a>
              </footer>
            </div>
          </Form>
        </section>
    )
  }
}

export default withRouter(Login)



// WEBPACK FOOTER //
// ./src/app/pages/login/containers/Login.js